/*
 * @Author: your name
 * @Date: 2020-11-24 09:33:11
 * @LastEditTime: 2021-11-09 14:10:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/store/mudules/localStorage.js
 */

import {
  GET_VENUE_CLOSE_POPUP_ONCE_TIME,
  SET_VENUE_CLOSE_POPUP_ONCE_TIME,
  DEL_VENUE_CLOSE_POPUP_ONCE_TIME,
  GET_VENUE_ONLINE_CLOSE_POPUP_ONCE_TIME,
  SET_VENUE_ONLINE_CLOSE_POPUP_ONCE_TIME,
  DEL_VENUE_ONLINE_CLOSE_POPUP_ONCE_TIME,
} from './mutations'

// initial state
const state = () => ({
  popupTime: '',
  onlinePopupTime: '',
})

// getters
const getters = {}

// actions
const actions = {

}

// mutations
const mutations = {
  [GET_VENUE_CLOSE_POPUP_ONCE_TIME](state) {
    state.popupTime = localStorage.getItem('venueClosePopupOnceTime')
  },

  [GET_VENUE_ONLINE_CLOSE_POPUP_ONCE_TIME](state) {
    state.onlinePopupTime = localStorage.getItem('venueOnlineClosePopupOnceTime')
  },

  [SET_VENUE_CLOSE_POPUP_ONCE_TIME](state, nowTime) {
    localStorage.setItem('venueClosePopupOnceTime', nowTime)
  },

  [SET_VENUE_ONLINE_CLOSE_POPUP_ONCE_TIME](state, nowTime) {
    localStorage.setItem('venueOnlineClosePopupOnceTime', nowTime)
  },

  [DEL_VENUE_CLOSE_POPUP_ONCE_TIME](state) {
    localStorage.removeItem('venueClosePopupOnceTime')
    state.popupTime = ''
  },

  [DEL_VENUE_ONLINE_CLOSE_POPUP_ONCE_TIME](state) {
    localStorage.removeItem('venueOnlineClosePopupOnceTime')
    state.onlinePopupTime = ''
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}